import { CheckCircle, CircleDashed, Eye, XCircle } from '@phosphor-icons/react'

import { theme } from '@reveni-io/reveni-ui'

import { lineItemStatuses as shipmentLineItemStatuses } from '@/parcels/constants'
import { statuses as returnLineItemStatuses } from '@/returns/constants'

export const getValidationSummaryLineTypes = () => {
  return {
    [returnLineItemStatuses.inProgress]: {
      singularText: '1 producto pendiente',
      pluralText: '{{count}} productos pendientes',
      Icon: CircleDashed,
      iconColor: theme.legacy.palette.grey.tone500,
    },
    [returnLineItemStatuses.accepted]: {
      singularText: '1 producto aceptado',
      pluralText: '{{count}} productos aceptados',
      Icon: CheckCircle,
      iconColor: theme.legacy.palette.teal.tone700,
    },
    [returnLineItemStatuses.rejected]: {
      singularText: '1 producto rechazado',
      pluralText: '{{count}} productos rechazados',
      Icon: XCircle,
      iconColor: theme.legacy.palette.red.tone500,
    },
    [returnLineItemStatuses.forReview]: {
      singularText: '1 producto por revisar',
      pluralText: '{{count}} productos por revisar',
      Icon: Eye,
      iconColor: theme.legacy.palette.orange.tone500,
    },
    [shipmentLineItemStatuses.packed]: {
      singularText: '1 producto empaquetado',
      pluralText: '{{count}} productos empaquetados',
      Icon: CheckCircle,
      iconColor: theme.legacy.palette.teal.tone700,
    },
    [shipmentLineItemStatuses.pending]: {
      singularText: '1 producto pendiente',
      pluralText: '{{count}} productos pendientes',
      Icon: CircleDashed,
      iconColor: theme.legacy.palette.grey.tone500,
    },
    [shipmentLineItemStatuses.discarded]: {
      singularText: '1 producto descartado',
      pluralText: '{{count}} productos descartados',
      Icon: XCircle,
      iconColor: theme.legacy.palette.red.tone500,
    },
  }
}
